import { render, staticRenderFns } from "./PrivacyTool.vue?vue&type=template&id=0b3ca0f6&scoped=true"
import script from "./PrivacyTool.vue?vue&type=script&lang=ts"
export * from "./PrivacyTool.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyTool.vue?vue&type=style&index=0&id=0b3ca0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ca0f6",
  null
  
)

export default component.exports